module.exports = __webpack_public_path__ + "img/default-icon.fc60f40f.png";